module.exports = __webpack_public_path__ + "img/pikpay.9438d176.jpg";